var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{attrs:{"frameborder":"0","width":_vm.width,"height":_vm.height,"src":_vm.src,"allowfullscreen":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }